import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppRoot } from "./app/app-root";
import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#app");

if (!root) {
  throw new Error("#app root element not found");
}

createRoot(root).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
